<template>
  <div>
    <v-select
      v-model="customersSelected"
      :items="customers"
      item-text="name"
      item-value="id"
      :label="$t('pages.UserCustomer.Create.Committente')"
      required
      :error-messages="customersSelectedErrors"
      @change="
        $v.customersSelected.$touch();
        onCustomerChange($event);
      "
      @blur="$v.customersSelected.$touch()"
    ></v-select>
  </div>
</template>
<script>
import { validationMixin } from "vuelidate";
import usersApi from "../apiSmartLogistics/usersApi";
import { required } from "vuelidate/lib/validators";
import { Trans } from "@/plugins/Translation";
export default {
  mixins: [validationMixin],
  validations: {
    customersSelected: { required }
  },

  name: "customerComponent",
  //props: [ 'type' ],
  data: () => ({
    customersSelected: "",
    customers: []
  }),
  async created() {
    await this.$GAUserAuth.refreshUserInfo().then(() => {
      // todo: pass the logged user's mail
      usersApi
        .GetUserCustomer(this.$GAUserAuth.user.username)
        .then(response => {
          this.customers = response.data;
          if (this.customers.length == 1) {
            this.customersSelected = this.customers[0].id;
            this.$emit("customerChange", this.customersSelected);
          }
        });
    });
  },

  methods: {
    onCustomerChange() {
      this.$emit("customerChange", this.customersSelected);
    },
    validate: function() {
      this.$v.$touch();
    },
    clear: function() {
      this.customersSelected = "";
    }
  },

  computed: {
    customersSelectedErrors() {
      const errors = [];
      if (!this.$v.customersSelected.$dirty) return errors;
      !this.$v.customersSelected.required &&
        errors.push(
          this.currentLanguage.t("Validations.SelezionareCommittente")
        );
      return errors;
    },
    currentLanguage() {
      return Trans.i18n;
    }
  }
};
</script>
